export const TOKEN_KEY = "token_12345";
